import { ContentReference } from '@cfa/pathway-fe-shared/xp';

import Constants from '@/constants';

import { capitalizeFirstLetter, capitalizeWords } from './capitalize';

export const formatDocumentTag = (tag: string) => {
  switch (tag) {
    case Constants.RESTAURANT_CONTENT_TYPES.TEST:
    case Constants.RESTAURANT_CONTENT_TYPES.FRANCHISEE:
      return capitalizeFirstLetter(tag);
    case Constants.RESTAURANT_CONTENT_TYPES.BAY_CENTER:
      return capitalizeWords(tag);
    case Constants.RESTAURANT_CONTENT_TYPES.CFA_SUPPLY:
      return capitalizeWords(tag, true);
    case Constants.RESTAURANT_CONTENT_TYPES.OFF_MENU:
      return tag.split('-').map(capitalizeFirstLetter).join('-');
    default:
      return tag;
  }
};

const isPrimaryTag = (tag: string): boolean => {
  const primary = Constants.PRIMARY_ORDER_TAGS.find(primaryTag =>
    tag.toUpperCase().includes(primaryTag),
  );
  return !!primary;
};

const isSecondaryTag = (tag: string): boolean => {
  const secondary = Constants.SECONDARY_ORDER_TAGS.find(secondTag =>
    tag.toUpperCase().includes(secondTag),
  );
  return !!secondary;
};

const getTagOrderNum = (tag: string) => {
  if (isPrimaryTag(tag)) {
    return 2;
  } else if (isSecondaryTag(tag)) {
    return 1;
  } else {
    return 0;
  }
};

const getReferenceTagsOrderNum = (tags: string[]) => {
  const primaryTag = tags[0];
  const secondaryTag = tags[1];
  const primaryIndex = Constants.PRIMARY_ORDER_TAGS.findIndex(tag =>
    primaryTag?.toUpperCase().includes(tag),
  );
  const secondIndex = Constants.SECONDARY_ORDER_TAGS.findIndex(tag =>
    secondaryTag?.toUpperCase().includes(tag),
  );
  const primaryTagNum =
    primaryIndex > -1
      ? (Constants.PRIMARY_ORDER_TAGS.length - primaryIndex) * 10
      : 0;
  const secondTagNum =
    secondIndex > -1 ? Constants.SECONDARY_ORDER_TAGS.length - secondIndex : 0;
  return primaryTagNum + secondTagNum;
};

const sortTags = (tags?: string[]) => {
  if (!tags?.length) {
    return [];
  }
  return [...tags].sort(
    (tag1, tag2) => getTagOrderNum(tag2) - getTagOrderNum(tag1),
  );
};

export const sortDocumentsByTags = (
  references?: ContentReference[],
): ContentReference[] | null => {
  if (!references) {
    return null;
  }
  const referencesOrderedTags = references.map(document => ({
    ...document,
    tags: sortTags(document.tags).map(tag => formatDocumentTag(tag)),
  }));
  return [...referencesOrderedTags].sort(
    (ref1, ref2) =>
      getReferenceTagsOrderNum(ref2.tags) - getReferenceTagsOrderNum(ref1.tags),
  );
};

export const colorTag = (tag: string) => {
  if (!tag) {
    return 'default';
  }
  return tag.includes(Constants.RESTAURANT_CONTENT_TYPES.STC) ||
    tag.includes(Constants.RESTAURANT_CONTENT_TYPES.TG)
    ? 'darkGreen'
    : tag.includes(
          capitalizeFirstLetter(Constants.RESTAURANT_CONTENT_TYPES.TEST),
        )
      ? 'orange'
      : 'default';
};
